import { PRINTERSETTING } from "../../utils/api"
import axios from "../../utils/axios"

export const PrinterSettin=async(param)=>{
    const res=await axios.post(PRINTERSETTING,param);
    return res;
}